var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReDocWrapper',{attrs:{"specOrSpecUrl":(_vm.origin + "/" + (_vm.$route.params.domain) + "/" + (_vm.$route.params.module))}})}
var staticRenderFns = []

export { render, staticRenderFns }